const MEMBER_VIP_FIELDS = [
	"vipUpgradeValidTurnover",
	"membershipUpgradeBalance",
	"vipId",
];

const MEMBERSHIP_VIP_FIELDS = [
	"targetObtainCriteriaMode",
	"targetObtainMinBet",
	"targetObtainDeposit",
	"isMaxLevel",
	"name",
	"targetName",
];

const collectChanges = (current, incoming, fields) => {
	let changes = null;

	fields.forEach((field) => {
		const nextValue = incoming[field];

		if (nextValue === undefined || current[field] === nextValue) {
			return;
		}

		if (changes === null) {
			changes = {};
		}

		changes[field] = nextValue;
	});

	return changes;
};

/**
 * Merges the VIP progress fields carried by the heartbeat into the member.
 * Returns the exact same member reference when nothing changed, so that the
 * ~10s heartbeat does not retrigger `useEffect([memberData])` consumers.
 */
export const mergeVipProgressIntoMember = (prevMember, vipProgress) => {
	const member =
		prevMember && typeof prevMember === "object" ? prevMember : {};
	const vip = vipProgress && typeof vipProgress === "object" ? vipProgress : {};

	if (Object.keys(member).length === 0) {
		return prevMember;
	}

	const membership =
		member.membership && typeof member.membership === "object"
			? member.membership
			: null;

	const memberChanges = collectChanges(member, vip, MEMBER_VIP_FIELDS);
	const membershipChanges = collectChanges(
		membership || {},
		vip,
		MEMBERSHIP_VIP_FIELDS
	);

	if (memberChanges === null && membershipChanges === null) {
		return prevMember;
	}

	return {
		...member,
		...memberChanges,
		...(membershipChanges === null
			? {}
			: { membership: { ...membership, ...membershipChanges } }),
	};
};

export default mergeVipProgressIntoMember;
